import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { AlertMessage } from 'utilities/utils';
import { ACT_AS_KEY } from 'constants/constants';
import MultipleLevelMenu from 'components/Sidebar/elements/MultipleLevelMenu';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import { useWebsocket } from 'websocket';
import { setAuthSession } from 'auth/session';
import { MenuItemIcon } from 'components/Sidebar/elements/MenuItemIcon';
import { useGetApiV5Me } from 'api/v5/auth/auth';
import { usePostApiV5AuthCpaSwitcher } from 'api/v5/firms-users/firms-users';
import {
  handleInvalidSignInMethodError,
  isInvalidSignInMethodError,
} from 'utilities/error-utils';

const MultipleCpa = ({ homedata }) => {
  const websocket = useWebsocket();
  const isActingAsAnEmployee = localStorage.getItem(ACT_AS_KEY);
  const { data: meData } = useGetApiV5Me();
  const cpaSwitcher = usePostApiV5AuthCpaSwitcher();

  const items = useMemo(() => {
    if (meData?.cpa_data && homedata?.cpa_uuid) {
      const currentCpa = meData.cpa_data.find(
        (cpa) => cpa.cpa_uuid === homedata.cpa_uuid,
      );
      const otherCpas = meData.cpa_data.filter(
        (cpa) => cpa.cpa_uuid !== homedata.cpa_uuid,
      );

      return {
        id: currentCpa.cpa_uuid,
        label: currentCpa.cpa_name,
        image: currentCpa.cpa_logo_url || currentCpa.cpa_name,
        children: otherCpas.map((otherCpa) => ({
          ...otherCpa,
          id: otherCpa.cpa_uuid,
          label: otherCpa.cpa_name,
          image: otherCpa.cpa_logo_url || otherCpa.cpa_name,
        })),
      };
    }
    return undefined;
  }, [homedata, meData]);

  const switchCpa = useCallback(
    async (e, item) => {
      const cpaRedirectUrl = item.company_url;
      try {
        const result = await cpaSwitcher.mutateAsync({
          data: { cpa_uuid: item.cpa_uuid },
        });

        if (result.auth_token) {
          websocket.consumer.disconnect();
          localStorage.clear();
          setAuthSession({ auth_token: result.auth_token });
          window.location.replace(cpaRedirectUrl);
        } else {
          AlertMessage('error', 'Something went wrong', 3000);
        }
      } catch (error) {
        const isInvalidMethodError = isInvalidSignInMethodError(error);

        if (isInvalidMethodError) {
          handleInvalidSignInMethodError(error);
        } else {
          AlertMessage('error', 'Something went wrong', 3000);
        }
      }
    },
    [cpaSwitcher, websocket.consumer],
  );

  if (items?.id && items?.children?.length && !isActingAsAnEmployee) {
    return (
      <MultipleLevelMenu
        onSelect={switchCpa}
        component={
          <ListItemButton key={items.id}>
            <ListItemIcon>
              <MenuItemIcon iconClass="icon-switch-account" />
            </ListItemIcon>
            <ListItemText primary={items.label.toUpperCase()} />
          </ListItemButton>
        }
        menuItems={items}
      />
    );
  }

  return null;
};

const mapStateToProps = (state) => ({
  homedata: state.homeReducer.data,
});

export default connect(mapStateToProps)(MultipleCpa);
